export default "__VITE_ASSET__lfdHzgHZ__"